/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  EmptyTreeInfo,
  GetDepartmentAndWorkAreaTreeParams,
  GetDepartmentWorkareaTreeWithDutyRosterPermissionsRequest,
  GetSimpleWorkAreasByIdsParams,
  GetWorkareaModuleParams,
  PermissionTypeTreeInfo,
  SimpleWorkArea,
  TsModule,
  UserPermissionTreeInfo
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType , BodyType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getGetDepartmentAndWorkAreaTreeWithDutyRosterPermissionsUrl = () => {


  

  return `/api/WorkArea/GetDepartmentAndWorkAreaTreeWithDutyRosterPermissions`
}

export const getDepartmentAndWorkAreaTreeWithDutyRosterPermissions = async (getDepartmentWorkareaTreeWithDutyRosterPermissionsRequest: GetDepartmentWorkareaTreeWithDutyRosterPermissionsRequest, options?: RequestInit): Promise<PermissionTypeTreeInfo> => {
  
  return customInstance<PermissionTypeTreeInfo>(getGetDepartmentAndWorkAreaTreeWithDutyRosterPermissionsUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      getDepartmentWorkareaTreeWithDutyRosterPermissionsRequest,)
  }
);}




export const getGetDepartmentAndWorkAreaTreeWithDutyRosterPermissionsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getDepartmentAndWorkAreaTreeWithDutyRosterPermissions>>, TError,{data: BodyType<GetDepartmentWorkareaTreeWithDutyRosterPermissionsRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof getDepartmentAndWorkAreaTreeWithDutyRosterPermissions>>, TError,{data: BodyType<GetDepartmentWorkareaTreeWithDutyRosterPermissionsRequest>}, TContext> => {

const mutationKey = ['getDepartmentAndWorkAreaTreeWithDutyRosterPermissions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getDepartmentAndWorkAreaTreeWithDutyRosterPermissions>>, {data: BodyType<GetDepartmentWorkareaTreeWithDutyRosterPermissionsRequest>}> = (props) => {
          const {data} = props ?? {};

          return  getDepartmentAndWorkAreaTreeWithDutyRosterPermissions(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetDepartmentAndWorkAreaTreeWithDutyRosterPermissionsMutationResult = NonNullable<Awaited<ReturnType<typeof getDepartmentAndWorkAreaTreeWithDutyRosterPermissions>>>
    export type GetDepartmentAndWorkAreaTreeWithDutyRosterPermissionsMutationBody = BodyType<GetDepartmentWorkareaTreeWithDutyRosterPermissionsRequest>
    export type GetDepartmentAndWorkAreaTreeWithDutyRosterPermissionsMutationError = ErrorType<unknown>

    export const useGetDepartmentAndWorkAreaTreeWithDutyRosterPermissions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getDepartmentAndWorkAreaTreeWithDutyRosterPermissions>>, TError,{data: BodyType<GetDepartmentWorkareaTreeWithDutyRosterPermissionsRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getDepartmentAndWorkAreaTreeWithDutyRosterPermissions>>,
        TError,
        {data: BodyType<GetDepartmentWorkareaTreeWithDutyRosterPermissionsRequest>},
        TContext
      > => {

      const mutationOptions = getGetDepartmentAndWorkAreaTreeWithDutyRosterPermissionsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getGetDepartmentAndWorkAreaTreeUrl = (params: GetDepartmentAndWorkAreaTreeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["whereModule"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/WorkArea/GetDepartmentAndWorkAreaTree?${stringifiedParams}` : `/api/WorkArea/GetDepartmentAndWorkAreaTree`
}

export const getDepartmentAndWorkAreaTree = async (params: GetDepartmentAndWorkAreaTreeParams, options?: RequestInit): Promise<UserPermissionTreeInfo> => {
  
  return customInstance<UserPermissionTreeInfo>(getGetDepartmentAndWorkAreaTreeUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetDepartmentAndWorkAreaTreeQueryKey = (params?: GetDepartmentAndWorkAreaTreeParams,) => {
    return [
    `/api/WorkArea/GetDepartmentAndWorkAreaTree`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetDepartmentAndWorkAreaTreeQueryOptions = <TData = Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>, TError = ErrorType<unknown>>(params: GetDepartmentAndWorkAreaTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDepartmentAndWorkAreaTreeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>> = ({ signal }) => getDepartmentAndWorkAreaTree(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDepartmentAndWorkAreaTreeQueryResult = NonNullable<Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>>
export type GetDepartmentAndWorkAreaTreeQueryError = ErrorType<unknown>


export function useGetDepartmentAndWorkAreaTree<TData = Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>, TError = ErrorType<unknown>>(
 params: GetDepartmentAndWorkAreaTreeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>,
          TError,
          Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDepartmentAndWorkAreaTree<TData = Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>, TError = ErrorType<unknown>>(
 params: GetDepartmentAndWorkAreaTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>,
          TError,
          Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDepartmentAndWorkAreaTree<TData = Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>, TError = ErrorType<unknown>>(
 params: GetDepartmentAndWorkAreaTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetDepartmentAndWorkAreaTree<TData = Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>, TError = ErrorType<unknown>>(
 params: GetDepartmentAndWorkAreaTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDepartmentAndWorkAreaTreeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetDepartmentAndWorkAreaTreeSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>, TError = ErrorType<unknown>>(params: GetDepartmentAndWorkAreaTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDepartmentAndWorkAreaTreeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>> = ({ signal }) => getDepartmentAndWorkAreaTree(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDepartmentAndWorkAreaTreeSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>>
export type GetDepartmentAndWorkAreaTreeSuspenseQueryError = ErrorType<unknown>


export function useGetDepartmentAndWorkAreaTreeSuspense<TData = Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>, TError = ErrorType<unknown>>(
 params: GetDepartmentAndWorkAreaTreeParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDepartmentAndWorkAreaTreeSuspense<TData = Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>, TError = ErrorType<unknown>>(
 params: GetDepartmentAndWorkAreaTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDepartmentAndWorkAreaTreeSuspense<TData = Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>, TError = ErrorType<unknown>>(
 params: GetDepartmentAndWorkAreaTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetDepartmentAndWorkAreaTreeSuspense<TData = Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>, TError = ErrorType<unknown>>(
 params: GetDepartmentAndWorkAreaTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDepartmentAndWorkAreaTreeSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetWorkAreaTreeUrl = () => {


  

  return `/api/WorkArea/GetWorkAreaTree`
}

export const getWorkAreaTree = async ( options?: RequestInit): Promise<EmptyTreeInfo> => {
  
  return customInstance<EmptyTreeInfo>(getGetWorkAreaTreeUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetWorkAreaTreeQueryKey = () => {
    return [
    `/api/WorkArea/GetWorkAreaTree`
    ] as const;
    }

    
export const getGetWorkAreaTreeQueryOptions = <TData = Awaited<ReturnType<typeof getWorkAreaTree>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkAreaTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkAreaTreeQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkAreaTree>>> = ({ signal }) => getWorkAreaTree({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkAreaTree>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetWorkAreaTreeQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkAreaTree>>>
export type GetWorkAreaTreeQueryError = ErrorType<unknown>


export function useGetWorkAreaTree<TData = Awaited<ReturnType<typeof getWorkAreaTree>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkAreaTree>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkAreaTree>>,
          TError,
          Awaited<ReturnType<typeof getWorkAreaTree>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetWorkAreaTree<TData = Awaited<ReturnType<typeof getWorkAreaTree>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkAreaTree>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkAreaTree>>,
          TError,
          Awaited<ReturnType<typeof getWorkAreaTree>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetWorkAreaTree<TData = Awaited<ReturnType<typeof getWorkAreaTree>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkAreaTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetWorkAreaTree<TData = Awaited<ReturnType<typeof getWorkAreaTree>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkAreaTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetWorkAreaTreeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetWorkAreaTreeSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getWorkAreaTree>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkAreaTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkAreaTreeQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkAreaTree>>> = ({ signal }) => getWorkAreaTree({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkAreaTree>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetWorkAreaTreeSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkAreaTree>>>
export type GetWorkAreaTreeSuspenseQueryError = ErrorType<unknown>


export function useGetWorkAreaTreeSuspense<TData = Awaited<ReturnType<typeof getWorkAreaTree>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkAreaTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetWorkAreaTreeSuspense<TData = Awaited<ReturnType<typeof getWorkAreaTree>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkAreaTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetWorkAreaTreeSuspense<TData = Awaited<ReturnType<typeof getWorkAreaTree>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkAreaTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetWorkAreaTreeSuspense<TData = Awaited<ReturnType<typeof getWorkAreaTree>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkAreaTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetWorkAreaTreeSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetWorkareaModuleUrl = (params?: GetWorkareaModuleParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/WorkArea/GetWorkareaModule?${stringifiedParams}` : `/api/WorkArea/GetWorkareaModule`
}

export const getWorkareaModule = async (params?: GetWorkareaModuleParams, options?: RequestInit): Promise<TsModule> => {
  
  return customInstance<TsModule>(getGetWorkareaModuleUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetWorkareaModuleQueryKey = (params?: GetWorkareaModuleParams,) => {
    return [
    `/api/WorkArea/GetWorkareaModule`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetWorkareaModuleQueryOptions = <TData = Awaited<ReturnType<typeof getWorkareaModule>>, TError = ErrorType<unknown>>(params?: GetWorkareaModuleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkareaModule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkareaModuleQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkareaModule>>> = ({ signal }) => getWorkareaModule(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkareaModule>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetWorkareaModuleQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkareaModule>>>
export type GetWorkareaModuleQueryError = ErrorType<unknown>


export function useGetWorkareaModule<TData = Awaited<ReturnType<typeof getWorkareaModule>>, TError = ErrorType<unknown>>(
 params: undefined |  GetWorkareaModuleParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkareaModule>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkareaModule>>,
          TError,
          Awaited<ReturnType<typeof getWorkareaModule>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetWorkareaModule<TData = Awaited<ReturnType<typeof getWorkareaModule>>, TError = ErrorType<unknown>>(
 params?: GetWorkareaModuleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkareaModule>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkareaModule>>,
          TError,
          Awaited<ReturnType<typeof getWorkareaModule>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetWorkareaModule<TData = Awaited<ReturnType<typeof getWorkareaModule>>, TError = ErrorType<unknown>>(
 params?: GetWorkareaModuleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkareaModule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetWorkareaModule<TData = Awaited<ReturnType<typeof getWorkareaModule>>, TError = ErrorType<unknown>>(
 params?: GetWorkareaModuleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkareaModule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetWorkareaModuleQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetWorkareaModuleSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getWorkareaModule>>, TError = ErrorType<unknown>>(params?: GetWorkareaModuleParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkareaModule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkareaModuleQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkareaModule>>> = ({ signal }) => getWorkareaModule(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkareaModule>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetWorkareaModuleSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkareaModule>>>
export type GetWorkareaModuleSuspenseQueryError = ErrorType<unknown>


export function useGetWorkareaModuleSuspense<TData = Awaited<ReturnType<typeof getWorkareaModule>>, TError = ErrorType<unknown>>(
 params: undefined |  GetWorkareaModuleParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkareaModule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetWorkareaModuleSuspense<TData = Awaited<ReturnType<typeof getWorkareaModule>>, TError = ErrorType<unknown>>(
 params?: GetWorkareaModuleParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkareaModule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetWorkareaModuleSuspense<TData = Awaited<ReturnType<typeof getWorkareaModule>>, TError = ErrorType<unknown>>(
 params?: GetWorkareaModuleParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkareaModule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetWorkareaModuleSuspense<TData = Awaited<ReturnType<typeof getWorkareaModule>>, TError = ErrorType<unknown>>(
 params?: GetWorkareaModuleParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkareaModule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetWorkareaModuleSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetSimpleWorkAreasByIdsUrl = (params: GetSimpleWorkAreasByIdsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["workAreaIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/WorkArea/GetSimpleWorkAreasByIds?${stringifiedParams}` : `/api/WorkArea/GetSimpleWorkAreasByIds`
}

export const getSimpleWorkAreasByIds = async (params: GetSimpleWorkAreasByIdsParams, options?: RequestInit): Promise<SimpleWorkArea[]> => {
  
  return customInstance<SimpleWorkArea[]>(getGetSimpleWorkAreasByIdsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetSimpleWorkAreasByIdsQueryKey = (params?: GetSimpleWorkAreasByIdsParams,) => {
    return [
    `/api/WorkArea/GetSimpleWorkAreasByIds`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetSimpleWorkAreasByIdsQueryOptions = <TData = Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>, TError = ErrorType<unknown>>(params: GetSimpleWorkAreasByIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSimpleWorkAreasByIdsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>> = ({ signal }) => getSimpleWorkAreasByIds(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetSimpleWorkAreasByIdsQueryResult = NonNullable<Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>>
export type GetSimpleWorkAreasByIdsQueryError = ErrorType<unknown>


export function useGetSimpleWorkAreasByIds<TData = Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>, TError = ErrorType<unknown>>(
 params: GetSimpleWorkAreasByIdsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>,
          TError,
          Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSimpleWorkAreasByIds<TData = Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>, TError = ErrorType<unknown>>(
 params: GetSimpleWorkAreasByIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>,
          TError,
          Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSimpleWorkAreasByIds<TData = Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>, TError = ErrorType<unknown>>(
 params: GetSimpleWorkAreasByIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetSimpleWorkAreasByIds<TData = Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>, TError = ErrorType<unknown>>(
 params: GetSimpleWorkAreasByIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetSimpleWorkAreasByIdsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetSimpleWorkAreasByIdsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>, TError = ErrorType<unknown>>(params: GetSimpleWorkAreasByIdsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSimpleWorkAreasByIdsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>> = ({ signal }) => getSimpleWorkAreasByIds(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetSimpleWorkAreasByIdsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>>
export type GetSimpleWorkAreasByIdsSuspenseQueryError = ErrorType<unknown>


export function useGetSimpleWorkAreasByIdsSuspense<TData = Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>, TError = ErrorType<unknown>>(
 params: GetSimpleWorkAreasByIdsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSimpleWorkAreasByIdsSuspense<TData = Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>, TError = ErrorType<unknown>>(
 params: GetSimpleWorkAreasByIdsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSimpleWorkAreasByIdsSuspense<TData = Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>, TError = ErrorType<unknown>>(
 params: GetSimpleWorkAreasByIdsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetSimpleWorkAreasByIdsSuspense<TData = Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>, TError = ErrorType<unknown>>(
 params: GetSimpleWorkAreasByIdsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetSimpleWorkAreasByIdsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




